import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';

const url = "https://economia.awesomeapi.com.br/"// + `${url}json/last/USD-BRL`;
const urlCep = "https://cep.awesomeapi.com.br/json/"
// Retorna a ultima ocorrência das moedas selecionadas.
// Ex.: https://economia.awesomeapi.com.br/last/USD-BRL,EUR-BRL,BTC-BRL
// Retorna o endereço do CEP
// Ex.: https://cep.awesomeapi.com.br/json/05424020
const real = "R$";
//Execução servidor json local
// const url = "http://localhost:3001/"
const Dolar = ()=>{
  const [result, setResult] = useState([])
  useEffect (() => {
    axios
    // .get(`${url}USDBRL`).then(response => {//local
      .get(`${url}json/last/USD-BRL`).then(response => {//web
        setResult(response.data)
        })
    }, [])
    const  coinConverted = result.USDBRL;
    console.log('result ',coinConverted);
    if (coinConverted) {
      return(
        <div className="width">
          <h3>{coinConverted.name}:</h3>
          <p>Alta: {real} {coinConverted.high} </p>
          <p>Baixa: {real} {coinConverted.low} </p>
          <p>Compra: {real} {coinConverted.bid} </p>
          <p>Venda: {real} {coinConverted.ask} </p>
          <p>Atualização: {coinConverted.create_date} </p>
        </div>
      )
    }
      return(
        <div className="width">
          <p>Erro de rede... </p>
        </div>
      )
  }


const Euro = ()=>{
  const [result, setResult] = useState([])
  useEffect (() => {
    axios
    // .get(`${url}EURBRL`).then(response => {//local
      .get(`${url}json/last/EUR-BRL`).then(response => {//web
        setResult(response.data)
      })
    }, [])
    const coinConverted = result.EURBRL
    if (coinConverted) {
      return(
        <div className="width">
        <h3>{coinConverted.name}:</h3>
        <p>Alta: {real} {coinConverted.high} </p>
        <p>Baixa: {real} {coinConverted.low} </p>
        <p>Compra: {real} {coinConverted.bid} </p>
        <p>Venda: {real} {coinConverted.ask} </p>
        <p>Atualização: {coinConverted.create_date} </p>
        </div>
      )
    }
      return(
        <div className="width">
          <p>Erro de rede...</p>
        </div>
      )
}
const Btc = ()=>{
  const [result, setResult] = useState([])
  useEffect (() => {
    axios
      // .get(`${url}BTCBRL`).then(response => {//local
        .get(`${url}json/last/BTC-BRL`).then(response => {//web
        setResult(response.data)
      })
      }, [])
      const coinConverted = result.BTCBRL
      if (coinConverted) {
        return(
          <div className="width">
          <h3>{coinConverted.name}:</h3>
          <p>Alta: {real} {coinConverted.high} </p>
          <p>Baixa: {real} {coinConverted.low} </p>
          <p>Compra: {real} {coinConverted.bid} </p>
          <p>Venda: {real} {coinConverted.ask} </p>
          <p>Atualização: {coinConverted.create_date} </p>
          </div>
        )
      }
        return(
          <div className="width">
            <p>Erro de rede...</p>
          </div>
        )
}
const Form = (props) =>{
  const { handleChange, cep, resultCep } = props
  console.log('cep ', cep);

  if (resultCep !== '') {
      console.log('resultCep, ', resultCep);
  }

  return(<div className="width">
    <h3>Pesquisar cep:</h3>
    <input type="text" placeholder="Exemplo: 45980000"
           className="button" onChange={handleChange} />
           <Cep resultCep={resultCep} cep={cep} />
    </div>
  )
}

const Cep =(props)=>{
  const { resultCep, cep } = props
  if (resultCep !== '' ) {
    return(<div>
          <p>Cep: {resultCep.cep}</p>
          <p>Endereco: {resultCep.address_name}</p>
          <p>Estado: {resultCep.state}</p>
          <p>Cidade: {resultCep.city}</p>
          <p>DDD: {resultCep.ddd}</p>
      </div>
    )
  }
  if (cep === '' ) {
    return(<div>
          <p>Preencha o cep corretamente.</p>
      </div>
    )
  }
  return <p>Nenhum cep pesquisado.</p>
}
const App = (props)=> {
  const [resultCep, setResultCep] = useState('')
  const [cep, setCep] = useState('')
  const searchCep = () => {
    axios
      .get(`${urlCep}${cep}`).then(response => {
        setResultCep(response.data)
        })
    }
useEffect (searchCep, [cep])

  const handleChange = (event)=>{
    const newCep = event.target.value
    console.log(newCep);
    if (newCep.length === 8 ) {
      setCep(newCep)
    }
    if (newCep.length < 8 && newCep.length > 0) {
      setResultCep([])
    }

  }
    return (
      <div className="w3-mobile w3-display-content">
      <h1  className="w3-bar w3-red w3-padding">Cotação de moedas e BuscaCEP</h1>
          <div className="row">
            <Dolar />
            <Euro />
          </div>
        <div className="row">
          <Btc />
          <Form handleChange={handleChange} cep={cep}
                resultCep={resultCep} />
        </div>
      <h3  className="w3-padding">Cotação de moedas atualizadas a cada 30 segundos. Fonte: <a href="https://docs.awesomeapi.com.br/" title="Awesome Api cotação de moedas">API awesomeapi</a></h3>
      </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js